// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CompanyInfoRouteImport } from './routes/company-info'
import { Route as CsrPolicyRouteImport } from './routes/csr-policy'
import { Route as ModernSlaveryActPolicyRouteImport } from './routes/modern-slavery-act-policy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SustainabilityPolicyRouteImport } from './routes/sustainability-policy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlogBrandedUniformsTextileBanksSecureDisposalRouteImport } from './routes/blog.branded-uniforms-textile-banks-secure-disposal'
import { Route as BlogBusinessLaptopItDisposalChecklistRouteImport } from './routes/blog.business-laptop-it-disposal-checklist'
import { Route as BlogCertificateOfDestructionGuideRouteImport } from './routes/blog.certificate-of-destruction-guide'
import { Route as BlogConfidentialPaperBinnedByMistakeZagrebLessonRouteImport } from './routes/blog.confidential-paper-binned-by-mistake-zagreb-lesson'
import { Route as BlogEuTextileEprUkFirmsEuSitesUniformsRouteImport } from './routes/blog.eu-textile-epr-uk-firms-eu-sites-uniforms'
import { Route as BlogIcoConfidentialWasteDisposalGuideRouteImport } from './routes/blog.ico-confidential-waste-disposal-guide'
import { Route as BlogIcoMetPoliceThirdPartySuppliersDisposalRouteImport } from './routes/blog.ico-met-police-third-party-suppliers-disposal'
import { Route as BlogOfficeLaptopsLithiumBatteriesSafeDisposalRouteImport } from './routes/blog.office-laptops-lithium-batteries-safe-disposal'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CompanyInfoRoute = CompanyInfoRouteImport.update({
            id: '/company-info',path: '/company-info',getParentRoute: () => rootRouteImport
          })
const CsrPolicyRoute = CsrPolicyRouteImport.update({
            id: '/csr-policy',path: '/csr-policy',getParentRoute: () => rootRouteImport
          })
const ModernSlaveryActPolicyRoute = ModernSlaveryActPolicyRouteImport.update({
            id: '/modern-slavery-act-policy',path: '/modern-slavery-act-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SustainabilityPolicyRoute = SustainabilityPolicyRouteImport.update({
            id: '/sustainability-policy',path: '/sustainability-policy',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const BlogBrandedUniformsTextileBanksSecureDisposalRoute = BlogBrandedUniformsTextileBanksSecureDisposalRouteImport.update({
            id: '/branded-uniforms-textile-banks-secure-disposal',path: '/branded-uniforms-textile-banks-secure-disposal',getParentRoute: () => BlogRoute
          })
const BlogBusinessLaptopItDisposalChecklistRoute = BlogBusinessLaptopItDisposalChecklistRouteImport.update({
            id: '/business-laptop-it-disposal-checklist',path: '/business-laptop-it-disposal-checklist',getParentRoute: () => BlogRoute
          })
const BlogCertificateOfDestructionGuideRoute = BlogCertificateOfDestructionGuideRouteImport.update({
            id: '/certificate-of-destruction-guide',path: '/certificate-of-destruction-guide',getParentRoute: () => BlogRoute
          })
const BlogConfidentialPaperBinnedByMistakeZagrebLessonRoute = BlogConfidentialPaperBinnedByMistakeZagrebLessonRouteImport.update({
            id: '/confidential-paper-binned-by-mistake-zagreb-lesson',path: '/confidential-paper-binned-by-mistake-zagreb-lesson',getParentRoute: () => BlogRoute
          })
const BlogEuTextileEprUkFirmsEuSitesUniformsRoute = BlogEuTextileEprUkFirmsEuSitesUniformsRouteImport.update({
            id: '/eu-textile-epr-uk-firms-eu-sites-uniforms',path: '/eu-textile-epr-uk-firms-eu-sites-uniforms',getParentRoute: () => BlogRoute
          })
const BlogIcoConfidentialWasteDisposalGuideRoute = BlogIcoConfidentialWasteDisposalGuideRouteImport.update({
            id: '/ico-confidential-waste-disposal-guide',path: '/ico-confidential-waste-disposal-guide',getParentRoute: () => BlogRoute
          })
const BlogIcoMetPoliceThirdPartySuppliersDisposalRoute = BlogIcoMetPoliceThirdPartySuppliersDisposalRouteImport.update({
            id: '/ico-met-police-third-party-suppliers-disposal',path: '/ico-met-police-third-party-suppliers-disposal',getParentRoute: () => BlogRoute
          })
const BlogOfficeLaptopsLithiumBatteriesSafeDisposalRoute = BlogOfficeLaptopsLithiumBatteriesSafeDisposalRouteImport.update({
            id: '/office-laptops-lithium-batteries-safe-disposal',path: '/office-laptops-lithium-batteries-safe-disposal',getParentRoute: () => BlogRoute
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogBrandedUniformsTextileBanksSecureDisposalRoute: BlogBrandedUniformsTextileBanksSecureDisposalRoute,BlogBusinessLaptopItDisposalChecklistRoute: BlogBusinessLaptopItDisposalChecklistRoute,BlogCertificateOfDestructionGuideRoute: BlogCertificateOfDestructionGuideRoute,BlogConfidentialPaperBinnedByMistakeZagrebLessonRoute: BlogConfidentialPaperBinnedByMistakeZagrebLessonRoute,BlogEuTextileEprUkFirmsEuSitesUniformsRoute: BlogEuTextileEprUkFirmsEuSitesUniformsRoute,BlogIcoConfidentialWasteDisposalGuideRoute: BlogIcoConfidentialWasteDisposalGuideRoute,BlogIcoMetPoliceThirdPartySuppliersDisposalRoute: BlogIcoMetPoliceThirdPartySuppliersDisposalRoute,BlogOfficeLaptopsLithiumBatteriesSafeDisposalRoute: BlogOfficeLaptopsLithiumBatteriesSafeDisposalRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BlogRoute: BlogRouteWithChildren,CompanyInfoRoute: CompanyInfoRoute,CsrPolicyRoute: CsrPolicyRoute,ModernSlaveryActPolicyRoute: ModernSlaveryActPolicyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ServicesRoute: ServicesRouteWithChildren,SustainabilityPolicyRoute: SustainabilityPolicyRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)